import $ from 'jquery';
import Raven from '../lib/Raven';
import { domElements } from '../constants/selectors';
import ThickBoxModal from '../feedback/ThickBoxModal';
import { submitFeedbackForm } from '../feedback/feedbackFormApi';
import { getOrCreateBackgroundApp, initBackgroundApp, } from '../utils/backgroundAppUtils';
import { refreshToken } from '../constants/leadinConfig';
import { ProxyMessages } from '../iframe/integratedMessages';
function deactivatePlugin() {
    const href = $(domElements.deactivatePluginButton).attr('href');
    if (href) {
        window.location.href = href;
    }
}
function setLoadingState() {
    $(domElements.deactivateFeedbackSubmit).addClass('loading');
}
function submitAndDeactivate(e) {
    e.preventDefault();
    setLoadingState();
    const feedback = $(domElements.deactivateFeedbackForm)
        .serializeArray()
        .find(field => field.name === 'feedback');
    submitFeedbackForm(domElements.deactivateFeedbackForm)
        .then(() => {
        if (feedback && refreshToken) {
            const embedder = getOrCreateBackgroundApp(refreshToken);
            embedder.postMessage({
                key: ProxyMessages.TrackPluginDeactivation,
                payload: {
                    type: feedback.value.trim().replace(/[\s']+/g, '_'),
                },
            });
        }
    })
        .catch((err) => {
        Raven.captureException(err);
    })
        .finally(() => {
        deactivatePlugin();
    });
}
function init() {
    // eslint-disable-next-line no-new
    new ThickBoxModal(domElements.deactivatePluginButton, 'leadin-feedback-container', 'leadin-feedback-window', 'leadin-feedback-content');
    $(domElements.deactivateFeedbackForm)
        .off('submit')
        .on('submit', submitAndDeactivate);
    $(domElements.deactivateFeedbackSkip)
        .off('click')
        .on('click', deactivatePlugin);
}
initBackgroundApp(init);
